import { render, staticRenderFns } from "./index.vue?vue&type=template&id=480c1c03"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=480c1c03&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480c1c03')) {
      api.createRecord('480c1c03', component.options)
    } else {
      api.reload('480c1c03', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=480c1c03", function () {
      api.rerender('480c1c03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkDescText/index.vue"
export default component.exports